const selectors = {
  deliveryTimer: '[data-delivery-timer]'
}

class DeliveryTimer {
  constructor(elements) {
    if (!elements || !elements[0].dataset.settings) return;

    this.deliveryTimers = elements;
    this.options = JSON.parse(elements[0].dataset.settings);

    const now = new Date();
    this.timezoneConvertedDate = this.convertTimezone(now);

    this.now = {
      day: this.timezoneConvertedDate.getDate(),
      month: this.timezoneConvertedDate.toLocaleString('default', {month: 'long'}),
      year: this.timezoneConvertedDate.getFullYear()
    }
  }

  init() {
    // Get the time in the specified timezone
    const todayIsValid = this.options.eligible_days.includes(this.timezoneConvertedDate.getDay());

    if (todayIsValid) {
      this.updateMessage();
      this.x = setInterval(this.updateMessage.bind(this), 10000);
    }
  }

  convertTimezone(date) {
    return new Date((typeof date === "string" ? new Date(date) : date)
      .toLocaleString('en-US', {timeZone: this.options.timezone}));
  }

  updateMessage(thisData) {
    const t = thisData ? thisData : this;

    const nowInLoop = new Date();
    const timezoneConvertedDateInLoop = t.convertTimezone(nowInLoop); // current date-time in brisbane.
    const nowTime = timezoneConvertedDateInLoop.getTime();

    // Find the distance between now and the count down date
    const countDownDateTime =
      new Date(`${t.now.day} ${t.now.month}, ${t.now.year} ${t.options.delivery_cutoff}`).getTime();
    const distance = countDownDateTime - nowTime;

    // Time calculations for days, hours, minutes and seconds
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const message = hours > 0 ? `${hours} hours, ${minutes} mins` : `${minutes} mins`;

    t.deliveryTimers.forEach((el) => el.innerHTML =
      `<p>${t.options.message.replace('{{ countdown }}', `<strong>${message}</strong>`)}</p>`);

    // Return if the timer needs to keep running
    if (distance > 60000) return;

    // Clear Interval and hide the timer
    if (this.x) clearInterval(this.x);
    t.deliveryTimers.forEach((el) => el.style.display = 'none');
  }
}

export default function () {
  const deliveryTimerEl = document.querySelectorAll(selectors.deliveryTimer);
  if (!deliveryTimerEl.length) return;

  const deliveryTimer = new DeliveryTimer(deliveryTimerEl);
  deliveryTimer.init();
};
